import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import BonusInterface from '../../api/BonusInterface';
import { TimedBonusKeys } from '../../api/Constants';
import { PLATFORM } from '../../constants';
import NotificationContext from '../../context/NotificationContext';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import PushNotification from '../../lib/notifications/PushNotification';
import InboxMessagesProvider from '../InboxMessagesProvider';
import audio from '../../utils/audio';
import { FE_MISSIONS, FE_EVENTS, FE_SOCIAL, FE_MISSIONS_ICON_ANIMATION } from '../../utils/featureFlags/constants';
import { MISSIONS_EVENT_TYPES, MISSIONS_GAMEPLAY_STATUS } from '../../screens/Missions/constants';
import { sendMissionsEvent } from '../../screens/Missions/analytics/missionsLogger';
import Utils from '../../utils';
import { sendEventsEvent } from '../../screens/Events/analytics/eventsLogger';
import { EVENTS_EVENT_TYPES, EVENTS_FEATURE_STATUS } from '../../screens/Events/constants';
import _rewardCenterMiddleware from '../../screens/RewardCenter/utils/middleware';
import TimestampManager from '../../utils/TimestampManager';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import transformObjectResponseKeys from '../../utils/transformObjectResponseKeys';
import NavigationConstants from '../LobbyOverlay/NavigationConstants';

var BottomBar = /*#__PURE__*/function (_Component) {
  function BottomBar() {
    var _this2;

    _classCallCheck(this, BottomBar);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this2 = _callSuper2(this, BottomBar, [].concat(_args));
    _this2.state = {
      visible: true,
      openChest: false,
      videoAdsTimeUntilReset: 0,
      claimingBonus: false,
      isFirstRender: true
    };
    _this2.videoAdsTimer = undefined;

    _this2.checkTimerToReset = function (timeLeft) {
      clearTimeout(_this2.timerCheck);
      _this2.timerCheck = setTimeout(function () {
        return _this2._timedBonusReady();
      }, timeLeft);
    };

    _this2._checkTimedBonus = function (args) {
      if (args) {
        var tb = transformObjectResponseKeys(args, TimedBonusKeys);
        var newDate = new Date(tb.TIME_LEFT);
        tb.TIME_LEFT = newDate.getTime() - new Date().getTime();

        if (tb.TIME_LEFT <= 0) {
          _this2.setState(_objectSpread(_objectSpread({}, tb), {}, {
            openChest: true,
            TIME_LEFT: 0
          }));
        } else {
          _this2.checkTimerToReset(tb.TIME_LEFT);

          tb.TIME_LEFT = Date.now() + tb.TIME_LEFT;

          _this2.setState(_objectSpread(_objectSpread({}, tb), {}, {
            openChest: false
          }));
        }
      }
    };

    _this2._timedBonusReady = function () {
      _this2.setState({
        openChest: true,
        TIME_LEFT: 0
      });
    };

    _this2._showModal = function (modalType) {
      audio.onClick();
      var _this2$props = _this2.props,
          sidebarState = _this2$props.sidebarState,
          setSidebarState = _this2$props.setSidebarState;
      setSidebarState(!sidebarState);
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, modalType));
    };

    _this2._timedBonusHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, timeLeft;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              audio.onClick();
              audio.playCoinSfx();
              _context.prev = 2;

              _this2.setState({
                claimingBonus: true
              });

              _context.next = 6;
              return BonusInterface.claimTimedBonus();

            case 6:
              response = _context.sent;
              timeLeft = response.timeLeft;

              if (response) {
                Utils.getPlatform() !== PLATFORM.WEB && PushNotification.scheduleTimedBonusNotification(timeLeft);
                response.timeLeft = Date.now() + response.timeLeft * 1000;

                _this2.props.setTimedBonus(response);

                _this2._checkTimedBonus(response);

                _this2.props.getMissions({
                  playerId: _this2.props.playerId,
                  requestAssetsData: false
                }, {
                  subscribe: false,
                  forceRefetch: true
                });
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);

            case 14:
              _this2.setState({
                claimingBonus: false
              });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }));

    _this2._setVideoAdsTimeRemaining = function (secondsRemaining) {
      var timeRemaining = secondsRemaining * 1000;
      _this2.videoAdsTimer = TimestampManager.register(timeRemaining, _this2._videoAdsReady);

      _this2.setState({
        videoAdsTimeUntilReset: Date.now() + timeRemaining
      });
    };

    _this2._videoAdsReady = function () {
      _this2.setState({
        videoAdsTimeUntilReset: 0
      });
    };

    _this2._getMessageCount = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = _this2.props;
              _context2.next = 3;
              return InboxMessagesProvider.getMessageCount();

            case 3:
              _context2.t1 = _context2.sent;

              _context2.t0.updateUnreadMessageCount.call(_context2.t0, _context2.t1);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    _this2._onInboxUpdateHandler = function () {
      _this2._getMessageCount();
    };

    return _this2;
  }

  _inherits(BottomBar, _Component);

  return _createClass(BottomBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.state.isFirstRender && this.setState({
        isFirstRender: false
      });

      this._checkTimedBonus(this.props.timedBonus);

      this.props.getEvents({
        playerId: this.props.playerId,
        requestAssetsData: true
      });

      if (this.props.videoAds && this.props.videoAds.secondsUntilReset > 0) {
        this._setVideoAdsTimeRemaining(this.props.videoAds.secondsUntilReset);
      }

      InboxMessagesProvider.on(InboxMessagesProvider.EVENTKEY, this._onInboxUpdateHandler);

      this._getMessageCount();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var newNavState = nextProps.navState;

      if (newNavState !== this.props.navState) {
        switch (newNavState) {
          case NavigationConstants.HIDE_BOTTOM:
            this.setState({
              visible: false
            });
            break;

          case NavigationConstants.HIDE_BOTH:
            {
              this.setState({
                visible: false
              });
              break;
            }

          default:
            {
              this.setState({
                visible: true
              });
            }
        }
      }

      var newVideoAds = nextProps.videoAds;

      if (newVideoAds !== this.props.videoAds && newVideoAds.secondsUntilReset > 0) {
        this._setVideoAdsTimeRemaining(newVideoAds.secondsUntilReset);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      TimestampManager.unregister(this.videoAdsTimer);
      clearTimeout(this.timerCheck);
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps, nextState) {
      if (this.state.visible !== nextState.visible) {
        if (this.props.sharedWillUpdate) {
          this.props.sharedWillUpdate(nextProps, nextState);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _events$data,
          _events$data$eventsFe,
          _events$data2,
          _events$data2$eventsF,
          _this3 = this;

      var _this$props = this.props,
          missionsFeature = _this$props.missionsFeature,
          missionsAssetsPackage = _this$props.missionsAssetsPackage,
          rewardCenterNotification = _this$props.rewardCenterNotification,
          events = _this$props.events;

      var _useFeatureFlags = useFeatureFlags(),
          hasFeature = _useFeatureFlags.hasFeature;

      var showEventsButton = hasFeature(FE_EVENTS) && (events === null || events === void 0 ? void 0 : (_events$data = events.data) === null || _events$data === void 0 ? void 0 : (_events$data$eventsFe = _events$data.eventsFeatureState) === null || _events$data$eventsFe === void 0 ? void 0 : _events$data$eventsFe.eventsFeatureStatus) && (events === null || events === void 0 ? void 0 : (_events$data2 = events.data) === null || _events$data2 === void 0 ? void 0 : (_events$data2$eventsF = _events$data2.eventsFeatureState) === null || _events$data2$eventsF === void 0 ? void 0 : _events$data2$eventsF.eventsFeatureStatus) !== EVENTS_FEATURE_STATUS.INACTIVE;
      var showMissionsButton = hasFeature(FE_MISSIONS) && ![MISSIONS_GAMEPLAY_STATUS.PENDING, MISSIONS_GAMEPLAY_STATUS.PAUSED, MISSIONS_GAMEPLAY_STATUS.CANCELED].includes(missionsFeature) && missionsAssetsPackage;
      var showSocialFeature = hasFeature(FE_SOCIAL);
      var showMissionsIconAnimation = hasFeature(FE_MISSIONS) && hasFeature(FE_MISSIONS_ICON_ANIMATION);

      if (this.state.isFirstRender) {
        showMissionsButton && sendMissionsEvent(MISSIONS_EVENT_TYPES.DISPLAY_MISSIONS_ICON);
        this.state.showEventsButton && sendEventsEvent(EVENTS_EVENT_TYPES.DISPLAY_EVENTS_ICON);
      }

      return this.props.render(_objectSpread({
        canEnterVipRoom: this.props.canEnterVipRoom,
        isVipRoomUnlocked: this.props.isVipRoomUnlocked,
        showModal: this._showModal,
        timedBonusHandle: this._timedBonusHandler,
        videoAds: {
          remaining: this.props.videoAds.remaining,
          timeUntilReset: this.state.videoAdsTimeUntilReset
        },
        appBackground: this.props.appBackground,
        sidebarState: this.props.sidebarState,
        setSidebarState: this.props.setSidebarState,
        unreadMessageCount: this.props.unreadMessageCount,
        unreadOfferCount: this.props.unreadOfferCount,
        showMissionsButton: showMissionsButton,
        showEventsButton: showEventsButton,
        showSocialFeature: showSocialFeature,
        showMissionsIconAnimation: showMissionsIconAnimation,
        rewardCenterNotification: rewardCenterNotification,
        rewardCenterMiddleware: function rewardCenterMiddleware() {
          return _rewardCenterMiddleware(_objectSpread(_objectSpread({}, _this3.props), {}, {
            notificationContext: _this3.context
          }));
        }
      }, this.state));
    }
  }]);
}(Component);

BottomBar.contextType = NotificationContext;
export { BottomBar as default };